module.exports = __webpack_public_path__ + "img/subway_warszawa.ee91127.png";